import React, { forwardRef } from "react";
import { getImageURL } from "../../_helper/utils/image";

// Using forwardRef to allow ReactToPrint to reference this component
const PrintCertificate = forwardRef(
  ({ header_footer_setup_data, editorContent }, ref) => {
    // console.log("Daity", editorContent);
    return (
      <div ref={ref} className="p-1">
        {/* Certificate Header */}
        {header_footer_setup_data?.headerUrl && (
          <img
            className="w-[100%] mb-4"
            src={getImageURL(header_footer_setup_data?.headerUrl)}
            alt="Certificate Header"
          />
        )}

        {/* Certificate Body */}
        <div
          dangerouslySetInnerHTML={{ __html: editorContent }} // Display certificate content
          className="certificate-body"
        />

        {/* Signature */}
        {header_footer_setup_data?.printSignature &&
          header_footer_setup_data?.signatureImg && (
            <div className="mt-4 flex justify-end">
              <img
                src={getImageURL(header_footer_setup_data?.signatureImg)}
                alt="Signature"
              />
            </div>
          )}

        {/* Certificate Footer */}
        {header_footer_setup_data?.footerURL && (
          <img
            className="w-[100%] mt-4"
            src={getImageURL(header_footer_setup_data?.footerURL)}
            alt="Certificate Footer"
          />
        )}
      </div>
    );
  }
);

export default PrintCertificate;
